<div class="app-table-container">
  <div class="app-table-wrapper">
    <table mat-table [dataSource]="dataSource" matSort
           [matSortActive]="sort[0]" [matSortDirection]="sort[1]"
           [matSortDisableClear]="true">

      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
        <td mat-cell *matCellDef="let row" class="secondary">#{{row.id}}</td>
      </ng-container>

      <ng-container matColumnDef="studentName" sticky>
        <th mat-header-cell *matHeaderCellDef mat-sort-header>ФИО</th>
        <td mat-cell *matCellDef="let row">
          <a [routerLink]="['/tests/', testId, 'results', row.id]">{{row.studentName}}</a>
        </td>
      </ng-container>

      <ng-container matColumnDef="studentMail">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Почта</th>
        <td mat-cell *matCellDef="let row">{{row.studentMail}}</td>
      </ng-container>

      <ng-container matColumnDef="isTelegram">
        <th mat-header-cell *matHeaderCellDef>Telegram</th>
        <td mat-cell *matCellDef="let row">
          {{row.link?.trackTelegramUsers ? (row.isTelegram ? 'Да' : 'Нет') : '-'}}
        </td>
      </ng-container>

      <ng-container matColumnDef="startDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Начато</th>
        <td mat-cell *matCellDef="let row">
          <app-time-event *ngIf="row.startDate" [value]="row.startDate"></app-time-event>
        </td>
      </ng-container>

      <ng-container matColumnDef="finishDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Завершено</th>
        <td mat-cell *matCellDef="let row">
          <app-time-event *ngIf="row.finishDate" [value]="row.finishDate"></app-time-event>
        </td>
      </ng-container>

      <ng-container matColumnDef="checkDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Проверено</th>
        <td mat-cell *matCellDef="let row">
          <app-time-event *ngIf="row.checkDate" [value]="row.checkDate"></app-time-event>
        </td>
      </ng-container>

      <ng-container matColumnDef="points">
        <th mat-header-cell *matHeaderCellDef>Результат</th>
        <td mat-cell *matCellDef="let row">{{row.checkDate === null ? '-' : row.points}}/{{row.maxPoints}}</td>
      </ng-container>

      <ng-container matColumnDef="percent">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Процент</th>
        <td mat-cell *matCellDef="let row">{{row.checkDate === null ? '' : row.percent + '%'}}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

    </table>

    <div class="spinner-container" *ngIf="dataSource.loading$|async">
      <mat-spinner></mat-spinner>
    </div>
  </div>

  <mat-paginator [length]="dataSource.totalElements$|async"
                 [pageSize]="pageSize"
                 [pageSizeOptions]="pageSizeOptions"
                 [pageIndex]="pageNumber"></mat-paginator>

</div>
